import React from "react";
import "./Webinar.css";
import mantexting from "../../assets/mantexting.png";
import call from "../../assets/call.png";
import bagtimer from "../../assets/bag-timer.png";
import pen from "../../assets/pen.png";
import firstgirlimage from "../../assets/firstgirlimage.png";
import flag from "../../assets/flag.png";
import redphone from "../../assets/redphone.png";
import globe from "../../assets/globe.png";
import { FaLocationDot } from "react-icons/fa6";
import { BsGlobeCentralSouthAsia } from "react-icons/bs";
import { IoCall } from "react-icons/io5";
import { FaGlobe } from "react-icons/fa";
import dataAnPic from "../../assets/Data analyst.jpg"
import dataAiPic from "../../assets/data Analytics.png"
import contact from "../../assets/contact.jpeg"


const Webinar = () => {
  return (
    <>
      <div className="contact-us-body">
        <div className="about-us-main-body">
          <div className="about-us-body">
            <div style={{ marginBottom: "20px" }}>
              <p className="we-are-text">Unlocking AI Careers: The Power of Data Analytics with AI</p>
            </div>
            <div>
              <p className="higher-text">
                Join us on <strong>March 12, 2025, at 8:30 PM</strong> for an insightful webinar on how Data Analytics, powered by Artificial Intelligence, is transforming industries and unlocking new career opportunities. This session will explore the critical role of AI in data-driven decision-making, the essential skills needed to excel in this field, and emerging career pathways in <strong>AI and Analytics.</strong>
                <span style={{ marginTop: "50px" }}><br />Whether you are an aspiring data professional or an experienced practitioner looking to enhance your expertise, this webinar will provide valuable insights into the future of AI-driven Analytics and how you can leverage it for <strong>Career Upskill.</strong></span>
              </p>
            </div>
            <div className="watchh-btn-body">
              <button className="watchh-btn">Connect To Tech-Expert</button>
            </div>
          </div>
          <div>
            <img src={dataAiPic} alt="Man texting" className="youtube-logo" />
          </div>
        </div>

        <div className="webinar-heading-container">
          <p style={{ fontSize: "25px" }}>SPEAKER</p>
          <h1 className="webinar-heading">
            Upskill AI From The Best</h1>
        </div>

        <div className="about-us-main-body">
          <div>
            <img src={dataAnPic} alt="Man texting" className="youtube-logo" style={{ marginTop: "20px" }} />
          </div>
          <div className="about-us-body">
            <div style={{ marginBottom: "20px" }}>
              <p className="we-are-text">Pratap Singh</p>
              <p style={{ color: "#00008b", fontFamily: "Gotham", fontSize: "25px" }}>AI Data Analyst </p>
            </div>
            <div>
              <p className="higher-text">
                Experienced AI and Data Analytics professional with a strong background in data preparation, storytelling, and business intelligence. Proficient in the Microsoft BI stack, Python, and Apache Spark, I specialize in transforming raw data into actionable insights. My expertise lies in leveraging advanced analytics and visualization techniques to drive data-driven decision-making. Passionate about uncovering meaningful patterns and crafting compelling narratives, I thrive in building scalable data solutions that empower organizations to maximize their data potential.
              </p>
            </div>

          </div>

        </div>

        <div className="learner-body-cu">
          <div className="webinar-text-body">
            <p className="webinar-text">Join Us To Know More About <span style={{color: "#ff3131"}}>AI and Data Analytics Upskill</span>  For <span style={{color: "#ff3131"}}>100% Salary </span>Increase</p>
            <a
              href="https://teams.microsoft.com/l/meetup-join/19%3ameeting_Y2E3YTE2YTgtMGQwMi00ZWM2LTk1MWItZTM3Yjk3ZWE3MjQ5%40thread.v2/0?context=%7b%22Tid%22%3a%22db25847f-bae9-4439-bdc4-08b63dce14e1%22%2c%22Oid%22%3a%2201847440-dbd2-4db8-9bd9-69a42f857d69%22%7d"
              target="_blank"
              rel="noopener noreferrer"
              style={{ color: "#ff3131" }}
            >
              <button className="btn btn-primary">
                Join Now
              </button>
            </a>

          </div>
          
        </div>
        <hr/>

        <div className="indian-national-main-body cssadd">
          <div className="indian-second-body">
            <div className="indian-first-body">
              {/* <BsGlobeCentralSouthAsia className="flag-img" />
              <label className="indian-text">Indian Nationals</label> */}
            </div>
            <div className="indian-firstt-body">
              {/* <IoCall className="phone-img" />
              <label className="number-text">+91-89779 17381
              </label> */}
            </div>
          </div>
          <img className="" src={contact} alt="contact"/>
          <div className="indian-second-body">
            {/* <div className="indian-first-body">
              <FaGlobe className="flag-img" />
              <label className="indian-text">Indian Nationals</label>
            </div> */}
            <div className="indian-firstt-body">
              {/* <IoCall className="phone-img" />
              <label className="number-text">+91-89779 17381
              </label> */}
            </div>
          </div>
        </div>

        <div className="disclaimer-body">
          <p className="disclaimerr-text">Disclaimer</p>
          <p className="disclaimer-textt">
            Hruthi AI Tech Hub does not grant credit; credits are granted, accepted or
            transferred at the sole discretion of the diploma or degree. We advise you to enquire
            further regarding the suitability of this for your future prospects before enrolling...
          </p>
        </div>
      </div>
    </>
  );
};

export default Webinar;
